import * as React from 'react';
import IconBtn from '../IconBtn';
import { ptz } from '../../domain/socketSlice';

export default function CameraPTZ(props) {

    const { edgeId, _id, username, password, ip, onvif_addr, pt, z } = props;

    const _ptz = type => {
        ptz({ edgeId, cameraId: _id, type, username, password, ip, onvif_addr });
    }

    let width = 0;

    if (pt) width+=135;
    if (z) width+=65;

    return (
        <div style={{ position: 'fixed', bottom: 10, left: 10, zIndex: 999999, background: '#3b3b3b', width, height: 116, borderRadius: 5 }}>
            onvif_addr: {onvif_addr}
            {
                pt && <>
                    <IconBtn onMouseUp={() => _ptz('stop')} onMouseDown={() => _ptz('up')} key="1" size="small" style={{ position: 'absolute', top: 10, right: 50 }}>ptzUp</IconBtn>
                    <IconBtn onMouseUp={() => _ptz('stop')} onMouseDown={() => _ptz('right')} key="2" size="small" style={{ position: 'absolute', top: 40, right: 13 }}>ptzRight</IconBtn>
                    <IconBtn onMouseUp={() => _ptz('stop')} onMouseDown={() => _ptz('left')} key="3" size="small" style={{ position: 'absolute', top: 40, right: 85 }}>ptzLeft</IconBtn>
                    <IconBtn onMouseUp={() => _ptz('stop')} onMouseDown={() => _ptz('down')} key="4" size="small" style={{ position: 'absolute', top: 70, right: 50 }}>ptzDown</IconBtn>
                </>
            }
            {
                z && <>
                    <IconBtn onMouseUp={() => _ptz('zoomin')} onMouseDown={() => _ptz('zoomin')} key="5" size="small" style={{ position: 'absolute', top: 10, left: 15 }}>zoomIn</IconBtn>
                    <IconBtn onMouseUp={() => _ptz('zoomout')} onMouseDown={() => _ptz('zoomout')} key="6" size="small" style={{ position: 'absolute', top: 70, left: 15 }}>zoomOut</IconBtn>
                </>
            }
        </div>)
}